import React from 'react'

const ContentNotFound = () => {
  return <main>Oops Not found!</main>
}

export default ContentNotFound
